import { rem } from 'utils/fonts';

const Input = {
  baseStyle: {
    field: {
      _focus: {
        borderColor: 'pink.500',
      },
    },
  },
  variants: {
    outline: {
      field: {
        bg: 'white',
        borderRadius: '9px',
        padding: '0 19px 0 19px',
        fontSize: [rem(14), null, rem(16), null, null, null],
        _focus: {
          borderColor: 'pink.500',
          boxShadow: 'none',
        },
      },
    },
    underlined: {
      field: {
        border: 'none',
        borderBottom: `1px solid`,
        borderBottomColor: 'gray.200',
        bg: 'transparent',
        padding: 0,
        borderRadius: 0,
        _hover: {
          borderBottomColor: 'gray.400',
        },
        _focus: {
          borderBottomColor: 'pink.500',
        },
      },
    },
  },
};

export default Input;
